import { ReactElement } from 'react';
import { CloudCostsHeaderContainer } from '../../../../modules/cloudCosts/containers/CloudCostsHeader.container';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { CloudCostsRoute } from '../../../routes/user/cloudCosts.route';

export const CloudCostsView = (): ReactElement => {
  return (
    <DashboardContainer>
      <CloudCostsHeaderContainer />
      <CloudCostsRoute />
    </DashboardContainer>
  );
};
